import { ClientSearchModel } from './clientSearchModel';

export class ClientListModel {
    public clients: Array<ClientSearchModel>;
    public count: number;
}